import { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { makeStore, type AppStore } from '@/store';
import { validateEnv } from '@/env';

interface StoreProviderProps {
  children: React.ReactNode;
}

/**
 * Redux Store Provider for Next.js App Router
 *
 * Uses useState with lazy initialization to ensure store is only created once.
 * This pattern is recommended for Next.js App Router to avoid
 * recreating the store on every render.
 */
export function StoreProvider({ children }: StoreProviderProps) {
  // Lazy initialization ensures makeStore() is only called once
  const [store] = useState<AppStore>(() => makeStore());

  // Validate environment variables after mount (client-side only)
  useEffect(() => {
    validateEnv();
  }, []);

  return <Provider store={store}>{children}</Provider>;
}
